/**
 * quote-button.js
 * Handles "Add / Remove from Quote" toggle buttons on product cards.
 * Works alongside quote-section.liquid which handles the panel + form.
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'get_quote_ids';

  /* ── Storage helpers ──────────────────────────────────────── */
  function getIds() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch { return []; }
  }

  function saveIds(ids) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  }

  /* ── Button state ─────────────────────────────────────────── */
  function setActive(btn, isActive) {
    btn.classList.toggle('active', isActive);
    btn.setAttribute('aria-pressed', String(isActive));
    const productTitle = btn.closest('[data-add-to-quote]')
      ?.getAttribute('data-add-to-quote');
    btn.setAttribute(
      'aria-label',
      isActive
        ? `Remove product ${productTitle} from quote`
        : `Add product ${productTitle} to quote`
    );
  }

  /* ── Sync all buttons for a given product ID ─────────────── */
  function syncButtons(productId, isActive) {
    document
      .querySelectorAll(`[data-add-to-quote="${productId}"]`)
      .forEach(btn => setActive(btn, isActive));
  }

  /* ── Init: mark buttons already in quote ─────────────────── */
  function initButtons() {
    const stored = getIds();
    document.querySelectorAll('[data-add-to-quote]').forEach(btn => {
      const id = Number(btn.dataset.addToQuote);
      setActive(btn, stored.includes(id));
    });
  }

  /* ── Click handler ────────────────────────────────────────── */
  function handleClick(e) {
    const btn = e.target.closest('[data-add-to-quote]');
    if (!btn) return;

    const productId = Number(btn.dataset.addToQuote);
    if (!productId) return;

    const ids      = getIds();
    const isActive = ids.includes(productId);

    if (isActive) {
      saveIds(ids.filter(id => id !== productId));
      syncButtons(productId, false);
    } else {
      saveIds([...ids, productId]);
      syncButtons(productId, true);
    }
  }

  /* ── Bootstrap ────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    initButtons();
    document.addEventListener('click', handleClick);
  });
})();

function imagevariantChangeto(e){
  const target = e.currentTarget;
  const image = target?.dataset?.image;
  const card = target.closest('.product-card-item');
  const imgsrcel = card.querySelector('.media .product-image');
  if(image && image.length > 0){
    e.preventDefault();
    const newUrl = image;

    imgsrcel.src = newUrl + '&width=100';
    imgsrcel.setAttribute('data-original', newUrl);

    const srcset = [
        180, 360, 540, 720, 900, 1080, 1296, 1512,
        1728, 1944, 2160, 2376, 2592, 2808, 3024
    ]
    .map(w => `${newUrl}&width=${w} ${w}w`)
    .join(', ');

    imgsrcel.srcset = srcset;
    imgsrcel.setAttribute('data-srcset', srcset);
  }
}
